/* import __COLOCATED_TEMPLATE__ from './create-topic-button.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./create-topic-button.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "",
  label: "topic.create",
  btnClass: "btn-default"
}));